import { api } from '../api';
import { openModal } from './modal';
import { toast } from './toast';

export function openChangePasswordModal(): void {
  openModal(
    `
    <h2 style="font-size:20px;margin-bottom:16px;">Change password</h2>
    <form id="change-password-form">
      <div class="field">
        <label>Current password</label>
        <input class="input" type="password" name="currentPassword" autocomplete="current-password" />
      </div>
      <div class="field">
        <label>New password</label>
        <input class="input" type="password" name="newPassword" autocomplete="new-password" placeholder="At least 6 characters" />
      </div>
      <div class="field">
        <label>Confirm new password</label>
        <input class="input" type="password" name="confirmPassword" autocomplete="new-password" />
      </div>
      <div class="form-error hidden" id="change-password-error"></div>
      <div style="display:flex;gap:10px;justify-content:flex-end;">
        <button type="button" class="btn btn-ghost" data-close>Cancel</button>
        <button type="submit" class="btn btn-primary">Update password</button>
      </div>
    </form>
  `,
    (body, close) => {
      const form = body.querySelector('#change-password-form') as HTMLFormElement;
      const errorEl = body.querySelector('#change-password-error') as HTMLElement;
      body.querySelector('[data-close]')!.addEventListener('click', close);
      body.querySelector<HTMLInputElement>('input[name="currentPassword"]')?.focus();

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.classList.add('hidden');
        const data = new FormData(form);
        const currentPassword = String(data.get('currentPassword') || '');
        const newPassword = String(data.get('newPassword') || '');
        const confirmPassword = String(data.get('confirmPassword') || '');

        if (!currentPassword || !newPassword) {
          errorEl.textContent = 'Please fill in all fields';
          errorEl.classList.remove('hidden');
          return;
        }
        if (newPassword.length < 6) {
          errorEl.textContent = 'New password must be at least 6 characters';
          errorEl.classList.remove('hidden');
          return;
        }
        if (newPassword !== confirmPassword) {
          errorEl.textContent = 'New passwords do not match';
          errorEl.classList.remove('hidden');
          return;
        }

        try {
          await api.patch('/auth/password', { currentPassword, newPassword });
          toast('Password updated');
          close();
        } catch (err: any) {
          errorEl.textContent = err.message || 'Could not update password';
          errorEl.classList.remove('hidden');
        }
      });
    }
  );
}
